// extracted by mini-css-extract-plugin
export default {"title":"WalletColumnTitle_title__BgU8P","infoIcon":"WalletColumnTitle_infoIcon__oXnkG"};